import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {isMobileDevice} from "./util/pwaUtils";

ReactDOM.render(<App />, document.getElementById('root'));

// Prevent PWA from being installable on non-mobile devices
window.addEventListener("load", function() {
    if (!isMobileDevice()) {
        console.log("Non-mobile device detected");
        document.querySelector('link[rel="manifest"]').remove();
    }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// Enabled PWA functionality
serviceWorker.register({
    onSuccess: (registration) => {
        console.log('PWA installed successfully');

        // Optional: Show install success message
        if ('Notification' in window && Notification.permission === 'granted') {
            new Notification('Land Machine is ready for offline use!');
        }
    },
    onUpdate: (registration) => {
        console.log('PWA update available');

        // Optional: Notify user of updates
        if (window.confirm('A new version is available! Refresh to update?')) {
            window.location.reload();
        }
    }
});

// Add PWA install prompt handling
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later
    deferredPrompt = e;

    // Optional: Show your own install promotion UI
    console.log('PWA install prompt available');
});

window.addEventListener('appinstalled', (evt) => {
    console.log('PWA was installed');
    deferredPrompt = null;
});

// Handle PWA offline/online status
window.addEventListener('online', () => {
    console.log('Back online');
});

window.addEventListener('offline', () => {
    console.log('Gone offline - using cached data');
});